var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShrink = function SvgShrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.818 8.196h4.898c.543 0 .964-.145 1.263-.436.299-.29.449-.7.449-1.228V1.779a.931.931 0 0 0-.278-.688.955.955 0 0 0-.702-.276.936.936 0 0 0-.968.964v.287l.212 3.203-2.219-2.307L1.735.275A.921.921 0 0 0 1.05 0C.751 0 .502.088.301.264a.886.886 0 0 0-.301.7c0 .138.026.268.077.39.05.123.124.234.218.333l2.75 2.664 2.373 2.158-3.293-.195h-.307c-.284 0-.522.086-.714.258a.858.858 0 0 0-.29.672c0 .275.097.503.29.683.192.18.43.27.714.27Zm8.722 9a.92.92 0 0 0 .685-.275.942.942 0 0 0 .271-.689v-.321l-.212-3.192 2.219 2.296 2.762 2.71a.92.92 0 0 0 .684.275c.3 0 .55-.088.75-.264.2-.176.301-.41.301-.7 0-.138-.026-.268-.077-.39a1.093 1.093 0 0 0-.218-.334l-2.762-2.686-2.373-2.158 3.294.207h.33c.283 0 .52-.088.708-.264a.884.884 0 0 0 .284-.678.884.884 0 0 0-.284-.677.999.999 0 0 0-.708-.264H11.26c-.543 0-.964.146-1.263.436-.299.291-.448.7-.448 1.229v4.775c0 .276.094.505.283.689a.975.975 0 0 0 .708.275Z",
    fill: "#014152"
  })));
};

export default SvgShrink;